import * as yup from 'yup';

import { emailRequiredValidator, passwordValidator } from '@mopla/utils';

const RegistrationValidationSchema = yup.object().shape({
	newEmail: emailRequiredValidator(),
	newPassword: passwordValidator(),
});

export default RegistrationValidationSchema;
